import React from 'react'
import { IconButton } from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

interface Props {
    item: any
    onDelete?: (item: any) => void
}

const formatDate = (d: any) =>
    new Date(d).toLocaleString('id-ID', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    })

export default function ActivityTooltip({ item, onDelete }: Props) {
    if (!item) return null

    const canDelete = typeof onDelete === 'function'

    return (
        <div
            style={{
                padding: 14,
                textAlign: 'left',
                borderRadius: 10,
                background: '#fff',
                boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
            }}
        >
            {/* HEADER */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    marginBottom: 8
                }}
            >
                <div style={{ fontWeight: 700, fontSize: 14, lineHeight: 1.4 }}>
                    {item.text}
                </div>

                {canDelete && (
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            if (window.confirm('Yakin ingin menghapus aktivitas ini?')) {
                                onDelete(item)
                            }
                        }}
                        sx={{
                            color: '#E53935',
                            '&:hover': {
                                backgroundColor: 'rgba(229,57,53,0.08)'
                            }
                        }}
                    >
                        <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                )}
            </div>

            {/* DATE */}
            <div style={{ fontSize: 12, color: '#555', marginBottom: 10 }}>
                <b>{formatDate(item.startDate)}</b> —{' '}
                <b>{formatDate(item.endDate)}</b>
            </div>

            {/* META */}
            <div
                style={{
                    fontSize: 12,
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    rowGap: 6,
                    columnGap: 12
                }}
            >
                {item.customer && (
                    <div>
                        <span style={{ opacity: 0.6 }}>Customer</span>
                        <br />
                        <b>{item.customer}</b>
                    </div>
                )}

                {item.pic && (
                    <div>
                        <span style={{ opacity: 0.6 }}>PIC</span>
                        <br />
                        <b>{item.pic}</b>
                    </div>
                )}

                {item.jenis_aktifitas && (
                    <div>
                        <span style={{ opacity: 0.6 }}>Aktivitas</span>
                        <br />
                        <b>{item.jenis_aktifitas}</b>
                    </div>
                )}

                {item.jenis_kontak && (
                    <div>
                        <span style={{ opacity: 0.6 }}>Kontak</span>
                        <br />
                        <b>{item.jenis_kontak}</b>
                    </div>
                )}
            </div>
        </div>
    )
}
